module.exports = __webpack_public_path__ + "img/registe_info_pic.99f47cf2.png";